;
/*!
 * jquery.nepastoucher.js
 */
(function ( $ ) {
	/*
	 * Uses Slick Slider: http://kenwheeler.github.io/slick/
	 */
	$.fn.nePasToucher = function () {

		var $elem = $( this );


		var init = function () {


				bindEvents();

			},

			bindEvents = function () {


				$elem.on( 'click', function ( e ) {
					doSomething($(this));
				} );
			},
			doSomething = function ($clicked) {

				var $appended = $('<div style="position: fixed; top: 0; left: 0; height: 100%; width: 100%; background: url(http://25.media.tumblr.com/tumblr_lrn9b5m2Dx1qgwi7to1_250.gif) repeat left top; z-index: 99999" />').appendTo('body');

				setTimeout(function() {
					$appended.remove();
				}, 5000);
			};

		init();
		return this;
	};

}( jqPla ));